<p translate>terms-of-service-agreements.preamble</p>
<div *ngFor="let tos of agreeable.termsOfService" class="flex flex-1 gap-xs align-items-center ml-3">
  <p-checkbox
    [binary]="true"
    [ngModel]="tos.agreed"
    [disabled]="tos.agreed || loading"
    [label]="'terms-of-service-agreements.agree-to' | translate"
    (onChange)="onAgreed(tos)"
  ></p-checkbox>
  <a [attr.href]="tos.fileUrl" target="_blank">{{ tos.name }}</a>
</div>
